<div class="organisation-settings-container">
	<div class="heading">
		<app-page-title title="Organisation Settings"></app-page-title>
		<app-step-navigator [stepConfig]="stepConfig"></app-step-navigator>
	</div>
	<div class="content">
		<router-outlet></router-outlet>
	</div>
</div>
